import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div data-testid="auth-loading" className="min-h-screen flex items-center justify-center bg-brand-bg text-white">
        <div className="mx-auto w-8 h-8 rounded-full border-2 border-indigo-400 border-t-transparent animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  if (adminOnly && !user.is_admin) {
    return (
      <div data-testid="auth-forbidden" className="min-h-screen flex items-center justify-center bg-brand-bg text-white px-6">
        <div className="max-w-md text-center glass rounded-2xl p-8">
          <div className="text-xs uppercase tracking-[0.3em] text-red-400">Access denied</div>
          <h1 className="mt-3 font-display text-2xl">You don&rsquo;t have admin access.</h1>
          <p className="mt-3 text-slate-300 text-sm">
            Signed in as <span className="text-white">{user.email}</span>. Only
            approved admin accounts can view this page.
          </p>
          <a href="/" className="inline-block mt-6 px-5 py-2.5 rounded-full bg-indigo-500 hover:bg-indigo-400 text-white text-sm transition-colors">
            Back to site
          </a>
        </div>
      </div>
    );
  }

  return children;
}
